import { redirect } from "@tanstack/react-router";

export interface CatalogRouteLocation {
  hash?: string;
  searchStr?: string;
}

interface BuildCatalogRouteRedirectInput {
  force?: boolean;
  location: CatalogRouteLocation;
  removeSearchParams?: string[];
  targetPath: string;
}

interface CatalogRouteRedirect {
  href: string;
  shouldRedirect: boolean;
}

export function buildCatalogRouteRedirect({
  force = false,
  location,
  removeSearchParams = [],
  targetPath,
}: BuildCatalogRouteRedirectInput): CatalogRouteRedirect {
  const searchParams = new URLSearchParams(location.searchStr ?? "");
  const removedParamPresent =
    searchParams.has("lang") || removeSearchParams.some((param) => searchParams.has(param));

  searchParams.delete("lang");
  removeSearchParams.forEach((param) => searchParams.delete(param));

  const query = searchParams.toString();
  const hash = location.hash ? `#${location.hash}` : "";

  return {
    href: `${targetPath}${query ? `?${query}` : ""}${hash}`,
    shouldRedirect: force || removedParamPresent,
  };
}

export function redirectCatalogRouteIfNeeded(input: BuildCatalogRouteRedirectInput): void {
  const target = buildCatalogRouteRedirect(input);
  if (!target.shouldRedirect) return;

  throw redirect({
    href: target.href,
    statusCode: 301,
  });
}
